import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ea8d36de&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8d36de')) {
      api.createRecord('ea8d36de', component.options)
    } else {
      api.reload('ea8d36de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ea8d36de&lang=pug", function () {
      api.rerender('ea8d36de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nav/leftNav/vipLeftNav/index.vue"
export default component.exports